import { DatePicker } from 'antd'
import clsx from 'clsx'
import React, { useEffect, useState } from 'react'

const { RangePicker } = DatePicker

import { useTranslation } from 'react-i18next'

import styles from './pure-date-range.module.scss'

interface PureDateRangeProps {
  label?: string
  from?: string
  to?: string
  colClass?: string
  moduleStyle?: string
  required?: boolean
}

export const PureDateRange = ({ label, colClass, moduleStyle, from = '', to = '', required = false, ...rest }: PureDateRangeProps) => {
  const { t } = useTranslation()
  const [fromPlaceholder, setFromPlaceholder] = useState<string>('')
  const [toPlaceholder, setToPlaceholder] = useState<string>('')

  useEffect(() => {
    setFromPlaceholder(from || t('common.from'))
    setToPlaceholder(to || t('common.to'))
  }, [from, to])

  return (
    <div className={clsx(colClass || 'col-12', moduleStyle || '', styles.customRangePicker)}>
      {label ? (
        <div className="label d-block mt-2 mb-1">
          {label}
          {required ? <span className={clsx('requiredAsterisk')}>*</span> : null}
        </div>
      ) : null}
      <RangePicker
        {...rest}
        placeholder={[fromPlaceholder, toPlaceholder]}
      />
    </div>
  )
}
